import { createSignal } from 'solid-js';
import type { ChatNotification } from './chatNotification';

const [latestMessage, setLatestMessage] = createSignal<ChatNotification | null>(null);

export const updateLatestMessage = (notification: ChatNotification) => {
  setLatestMessage(notification);
};

export const useLatestMessage = () => latestMessage;
